module.exports = __webpack_public_path__ + "static/media/pf44.a96f9f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf44.png
// module id = 2736
// module chunks = 0